import campaignApi from "@/api/campaign.api"

export const createCampaign = async (accountId, data) => {
  return await campaignApi.create(accountId, data)
}

export const getCampaigntList = async ({ accountId, pageNumber, pageSize, sortBy, sortDesc, search }) => {
  return await campaignApi.list(accountId, pageNumber, pageSize, sortBy, sortDesc, search)
}

export const getCampaign = async ({ accountId, id }) => {
  return await campaignApi.get(accountId, id)
}

export const updateCampaign = async ({ accountId, data }) => {
  return await campaignApi.update(accountId, data)
}

export const deleteCampaign = async ({ accountId, id }) => {
  return await campaignApi.deleteCampaign(accountId, id)
}

export const patchCampaign = async (accountId, data) => {
  return await campaignApi.patch(accountId, data)
}

export const createRuleChain = async (accountId, ruleChian) => {
  return await campaignApi.createRuleChain(accountId, ruleChian)
}

export const getRuleChains = async (accountId) => {
  return await campaignApi.getRuleChains(accountId)
}

export const getTargets = async (accountId) => {
  return await campaignApi.getTargets(accountId)
}

export const getTargetDetail = async (accountId, path, type) => {
  return await campaignApi.getTargetDetail(accountId, path, type)
}

export const getAdvertisers = async (accountId) => {
  return await campaignApi.getAdvertisers(accountId)
}

export const getInventory = async ({ accountId, offset, from, to, data }) => {
  return await campaignApi.getInventory(accountId, offset, from, to, data)
}

export const getReports = async ({ accountId, id }) => {
  return await campaignApi.getReports(accountId, id)
}

export const getAdvertisingDetails = async (accountId) => {
  return await campaignApi.getAdvertisingDetails(accountId)
}

export default {
  createCampaign,
  getCampaigntList,
  getCampaign,
  updateCampaign,
  patchCampaign,
  deleteCampaign,
  createRuleChain,
  getRuleChains,
  getTargets,
  getTargetDetail,
  getAdvertisers,
  getInventory,
  getReports,
  getAdvertisingDetails,
}
